import { useCallback, useEffect } from "react";
import { Modal } from "react-daisyui";
import { useTranslation } from "react-i18next";

import { IPriceListModalProps } from "./types";

import IconClose from "~/components/atoms/Icons/IconClose";
import Typo from "~/components/atoms/Typo";
import PriceListTable from "~/components/molecules/PriceListTable";
import { cn } from "~/utilities/cn";
import { ETypoColor } from "~/utilities/enums/Colors";
import { ETypoVariant } from "~/utilities/enums/Typo";

const PriceListModal: React.FC<IPriceListModalProps> = ({
  items,
  page,
  isLoading,
  onLoadMore,
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  const closeModalOnEscape = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (open) {
      window.addEventListener("keydown", closeModalOnEscape);
    } else {
      window.removeEventListener("keydown", closeModalOnEscape);
    }
    return () => window.removeEventListener("keydown", closeModalOnEscape);
  }, [open, closeModalOnEscape]);

  return (
    <Modal.Legacy
      open={open}
      className={cn(
        "w-11/12 max-w-[1200px] !bg-enquiryBackground lg:max-h-[90dvh]"
      )}
      onClickBackdrop={onClose}
    >
      <Modal.Header className="font-bold">
        <div className="flex w-full flex-row justify-between">
          <Typo
            variant={ETypoVariant.HEADER_32}
            tag="h4"
            className="flex-1 font-bold lg:text-header-24"
            color={ETypoColor.PROJECT_HEADING}
          >
            {t("price_list_title")}
          </Typo>
          <IconClose onClick={onClose} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="overflow-hidden">
          <PriceListTable isLoading={isLoading} wrapperClass="max-h-[400px]" />
        </div>
      </Modal.Body>
    </Modal.Legacy>
  );
};

export default PriceListModal;
